import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

// Assets
import home from './businessassets/homebusiness.svg'
import yourpage from './businessassets/yourpagebusiness.svg'
import settingssvg from './businessassets/settingsbusiness.svg'
import analyticssvg from './businessassets/analyticsbusiness.svg'
import widgetssvg from './businessassets/widgetbusiness.svg'
import inteSvg from './businessassets/intel.svg'
import questionSvg from './businessassets/questionSvg.svg'
import blackicon from '../../assets/FINALDARKLOGO.svg'
import pricingSvg from './businessassets/dollar.svg'

export default function Sidebanner() {
  const navigate = useNavigate()
  const location = useLocation()

  // Helper to keep code clean
  const navItems = [
    { name: 'Home', path: '/business/home', icon: home },
    { name: 'Your Page', path: '/business/your-page', icon: yourpage },
    { name: 'Pricing & Plans', path: '/business/pricing', icon: pricingSvg }, // Consider a different icon here later
    { name: 'Analytics', path: '/business/analytics', icon: analyticssvg },
    { name: 'Intel Reports', path: '/business/business-intel', icon: inteSvg },
    { name: 'Widget', path: '/business/widget', icon: widgetssvg },
    { name: 'Faqs', path: '/business/faqs', icon: questionSvg },
    { name: 'Settings', path: '/business/settings', icon: settingssvg },
  ]

  return (
    <div className='w-[250px] xl:w-[350px]  flex flex-col hidden lg:flex h-screen fixed bg-white border-r border-gray-100 right-0 top-0 z-50'>
      <Helmet>
        <title>Sitemanifest Business</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* 1. TOP SCROLLABLE NAV AREA */}
      <div className='flex-1 overflow-y-auto pt-8 px-4  custom-scrollbar'>
        <div className='flex flex-col gap-2 xl:gap-4'>
          {navItems.map((item) => {
            const isActive = location.pathname === item.path
            return (
              <div
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full cursor-pointer gap-4 px-5 flex flex-row items-center h-[48px] xl:h-[54px] rounded-lg transition-all duration-200 ${
                  isActive ? "bg-[#32596E] text-white shadow-md" : "bg-white text-[#323232] hover:bg-gray-50"
                }`}
              >
                <img
                  className={`w-5 h-5 xl:w-6 xl:h-6 transition-all ${
                    isActive ? 'brightness-0 invert' : 'brightness-0 opacity-70'
                  }`}
                  src={item.icon}
                  alt={item.name}
                />
                <span className='font-poppins text-[14px] xl:text-[16px] tracking-wide font-medium'>
                  {item.name}
                </span>
              </div>
            )
          })}
        </div>
      </div>

      {/* 2. FIXED BOTTOM LOGO AREA */}
      <div className='p-8 border-t border-gray-50'>
        <div className='flex flex-row gap-4 items-center'>
          <img className='w-8 xl:w-10' src={blackicon} alt="Sitemanifest Logo" />
          <div className='flex flex-col'>
            <span className='font-staat text-[18px] xl:text-[22px] leading-none tracking-[3px] text-[#323232] uppercase'>
              Sitemanifest
            </span>
            <span className='font-staat text-[12px] xl:text-[14px] tracking-[2px] text-[#32596E] uppercase opacity-80'>
              Business
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}